import React from "react";
import moneyBack from "../../../images/pricing/moneyBack.svg";

const PricingFooter = () => (
  <div className="pricing-footer row mt-4">
    <div className="col-12 col-md-12">
      <div className="d-flex">
        <img src={moneyBack} alt="money-back" />
        <div>
          <p className="d-inline-block">
            All our paid plans are covered by our 30-day refund policy so if
            Hexomatic is not a right fit for your business we provide a full
            refund.
          </p>
          <p>
            Premium credits are an optional add-on you can purchase separately
            to our plans to access automations that use 3rd party services or
            crowdsourced tasks.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default PricingFooter;
